module.exports = __webpack_public_path__ + "img/panoramic-img.e790f09f.png";